import { Outlet } from "react-router-dom";
import { Fragment } from 'react';
import Sidebar from "../Navgations/Navigation.js";
import HeaderSection from "../Headers/HeaderSection";
// import StickyHeadTable from '../Table/TablePagination'
import NavSidebar from '../Navgations/Nav';
// import TablePagination from '../Table/TablePagination.js'
import styled from "styled-components";
import { useSelector } from "react-redux";
import { NavSlice } from "../../redux/navSlice.js"
import FooterSection from "../Footers/FooterSection.js";


const Main = styled.main`
  background-color: var(--color-grey-50);
  padding: 4rem 4.8rem 6.4rem;
  overflow: scroll;
`;

const Container = styled.div`
//   max-width: 120rem;
  margin: 0 auto;
  display: flex;    
  flex-direction: column;
  gap: 3.2rem;
`;


const MainLayout = (props) => {
    const flagStatus = useSelector(state => state.nav.status)// console.log("****",state.order.data

    // console.log("..................", flagStatus)
    return (
        <Fragment>
            <HeaderSection />
            <Sidebar />
            {/* <Main> */}
            <Container>
                <div className="main-ingrid">
                <div className={`main-divi ${flagStatus ? 'active-cont' : '0px'}`}>
                    <div className="aside-box ">
                    
                        <Outlet />

                    </div>

                </div>
                </div>
            </Container>
            {/* </Main> */}
            {/* <main><p>test</p></main> */}
            <FooterSection/>
        </Fragment>
    );
};
export default MainLayout;
